import React, { useRef, useContext, useState, useEffect } from "react";
import { FaSync, FaPrint, FaPlus } from "react-icons/fa";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

import { Button, useDisclosure, Box } from "@chakra-ui/react";
import List from "./List";
import C_Modal from "./C_Modal";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// import { StudentContext } from "../../Context/StudentContext";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import DivisionModal from "./Division Modal";
import Print_classAsssign from "./Print_classAsssign";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Class = () => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [classData, setClassData] = useState([]);
  const {
    isOpen: isDivisionOpen,
    onOpen: onDivisionOpen,
    onClose: onDivisionClose,
  } = useDisclosure();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef(); // Reference to Print_pdf_class_list component
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  const handleClick = () => {
    navigate("/teachers/add"); // Navigate to the desired route
  };

  const sortData = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedData = [...classData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });

    setClassData(sortedData);
    setSortConfig({ key, direction });
  };

  const renderSortIcon = (columnKey) => {
    if (sortConfig.key === columnKey) {
      return sortConfig.direction === "asc" ? <FaSortUp /> : <FaSortDown />;
    }
    return <FaSort />;
  };

  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };

  const fetchClassData = async () => {
    try {
      const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

      const response = await fetch(
        `${BASE_URL}/admin/class/list_all_class.php?school_id=${school_id}`
      );
      const data = await response.json();
      console.log("Fetched Data:", data);
      if (data && data.success && Array.isArray(data.data)) {
        setClassData(data.data); // Access the data key inside the response object
        setIsDataLoaded(true); // Mark data as loaded
      }
    } catch (error) {
      console.error("Error fetching class data:", error);
    }
  };
  useEffect(() => {
    fetchClassData();
  }, []);
  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px" }}>Class Assign</h1>
          <div className="action-buttons">
            <div className="export-dropdown">
              <Button
                className="export-button"
                display={{ base: "none", md: "flex" }}
                backgroundColor="white"
                fontSize="11px"
                boxShadow="md"
                onClick={handlePrint} // Attach the print handler here
              >
                <FaPrint color="#515B73" />
                Print PDF
              </Button>
            </div>
            {/* Division Button */}
            {/* Division Button */}
            <Button
              onClick={onDivisionOpen}
              leftIcon={<FaPlus />}
              colorScheme="teal"
              boxShadow="md"
              display={{ base: "none", md: "flex" }}
            >
              Division
            </Button>
            <Button
              className="add-teacher-button"
              onClick={onOpen}
              leftIcon={<FaPlus />}
              colorScheme="teal" // Optional: You can customize the color scheme
            >
              <Box display={{ base: "none", md: "block" }}>Add Class</Box>
            </Button>
          </div>
        </div>

        <div className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          /{" "}
          <Link
            to="/class/list"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Class</span>
          </Link>{" "}
          / <span>Class Assign</span>
        </div>
      </div>

      <div id="teacher-list-content">
        <List />
      </div>

      <C_Modal
        isOpen={isOpen}
        onClose={onClose}
        refreshClassList={fetchClassData}
      />
      {/* Division Modal */}
      <DivisionModal isOpen={isDivisionOpen} onClose={onDivisionClose} />

      {/* Include Print_pdf_class_list but keep it hidden on the UI */}
      <div style={{ display: "none" }}>
        <Print_classAsssign ref={printComponentRef} classData={classData} />
      </div>
    </div>
  );
};

export default Class;
